import {TRIGGER_ACTION_TYPE} from '@constants/trigger/trigger-action-type.constant';
import {MessageContentType} from '@models/adminstration/machine/trigger/trigger-query/message-content-type';
import {
  AdditionalMessageField
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';

export class Trigger {
  bannedInactive: boolean;
  bannedUserSubscriptions: string | null;
  delayInSeconds: string | null;
  email: string;
  id: number;
  initQueryExecuted: boolean;
  isParentMachine: boolean;
  message: string;
  name: string;
  notificationSubscriptions: string[] | null;
  offlineMailSent: boolean;
  offlineNotificationSent: boolean;
  parent: string;
  parentId: number;
  subject: string;
  topic: string | null;
  triggerActionType: TRIGGER_ACTION_TYPE;
  usedInActiveTrigger: boolean;
  messageContentType: MessageContentType = MessageContentType.TEXT;
  additionalMessageFields: AdditionalMessageField[] | null;

  constructor(trigger?: Trigger) {
    this.bannedInactive = trigger?.bannedInactive || false;
    this.bannedUserSubscriptions = trigger?.bannedUserSubscriptions || null;
    this.delayInSeconds = trigger?.delayInSeconds || null;
    this.email = trigger?.email || '';
    this.id  = trigger?.id || -1;
    this.initQueryExecuted = trigger?.initQueryExecuted || false;
    this.isParentMachine = trigger?.isParentMachine || false;
    this.message = trigger?.message || '';
    this.name = trigger?.name || '';
    this.notificationSubscriptions = trigger?.notificationSubscriptions || null;
    this.offlineMailSent = trigger?.offlineMailSent || false;
    this.offlineNotificationSent = trigger?.offlineNotificationSent || false;
    this.parent = trigger?.parent || '';
    this.parentId  = trigger?.parentId || -1;
    this.subject = trigger?.subject || '';
    this.topic = trigger?.topic || null;
    this.triggerActionType = trigger?.triggerActionType || TRIGGER_ACTION_TYPE.UNKNOWN;
    this.usedInActiveTrigger = trigger?.usedInActiveTrigger || false;
    this.messageContentType = trigger?.messageContentType || MessageContentType.TEXT;
    this.additionalMessageFields = trigger?.additionalMessageFields || null;
  }
}
